import { render, staticRenderFns } from "./VxServerSideTable.vue?vue&type=template&id=be0823ec&scoped=true"
import script from "./VxServerSideTable.vue?vue&type=script&lang=js"
export * from "./VxServerSideTable.vue?vue&type=script&lang=js"
import style0 from "./VxServerSideTable.vue?vue&type=style&index=0&id=be0823ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0823ec",
  null
  
)

export default component.exports